import { render, staticRenderFns } from "./EditRecipientWhatsAppEmailItem.vue?vue&type=template&id=0e1b8b5d"
import script from "./EditRecipientWhatsAppEmailItem.vue?vue&type=script&lang=js"
export * from "./EditRecipientWhatsAppEmailItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports